import { useLayoutEffect } from 'react';

const DIALOG_STICKY_ID = 'dialog-sticky-container';
const SCROLL_BOTTOM_GAP = 8;

// Define max-height da coluna dos collapses com base no espaço visível do modal, para overflow-y funcionar mesmo quando a cadeia flex do Dialog não limita altura.
export default function useCollapsesScrollHeight(mainRef, deps = []) {
  useLayoutEffect(() => {
    const mainEl = mainRef.current;
    if (!mainEl) {
      return undefined;
    }

    const getSticky = () => mainEl.closest(`#${DIALOG_STICKY_ID}`);

    const sync = () => {
      const sticky = getSticky();
      if (!sticky) {
        return;
      }

      const dialogRoot = sticky.parentElement;
      const mainRect = mainEl.getBoundingClientRect();
      let bottomLimit = dialogRoot
        ? dialogRoot.getBoundingClientRect().bottom
        : window.innerHeight;

      const footerEl = dialogRoot?.lastElementChild;
      if (footerEl && footerEl !== sticky) {
        const footerTop = footerEl.getBoundingClientRect().top;
        if (footerTop > mainRect.top) {
          bottomLimit = footerTop;
        }
      }

      const available = bottomLimit - mainRect.top - SCROLL_BOTTOM_GAP;
      mainEl.style.maxHeight = `${Math.max(120, available)}px`;
      mainEl.style.overflowY = 'auto';
    };

    sync();
    requestAnimationFrame(() => {
      requestAnimationFrame(sync);
    });

    const ro = new ResizeObserver(sync);
    ro.observe(mainEl);

    const sticky = getSticky();
    if (sticky) {
      ro.observe(sticky);
      if (sticky.parentElement) {
        ro.observe(sticky.parentElement);
      }
    }

    let mutationObserver;
    if (sticky) {
      mutationObserver = new MutationObserver(() => {
        sync();
        requestAnimationFrame(sync);
      });
      mutationObserver.observe(sticky, {
        childList: true,
        subtree: true,
      });
    }

    window.addEventListener('resize', sync);

    return () => {
      ro.disconnect();
      mutationObserver?.disconnect();
      window.removeEventListener('resize', sync);
    };
  }, deps);
}
